<template>
  <a
    :accesskey="accesskey"
    :id="id"
    :title="accesskeyTitle"
    href=""
    @click="preventDefaultBehaviors"
  >
    :::
  </a>
  <!-- <router-link
    :accesskey="accesskey"
    :to="to"
    :id="id"
    :title="accesskeyTitle"
    @click.native="reAnchor"
    @keyup.native.enter="reAnchor"
    replace
  >
    :::
  </router-link> -->
</template>

<script>
// @click.native="scrollFix('#scroll')"
export default {
  name: "AccesskeyLink",
  props: {
    accesskey: {
      required: true,
      type: String,
      default: "",
    },
    // to: {
    //   type: [String, Array],
    //   default: "",
    // },
    title: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    accesskeyTitle() {
      return `${this.title}`;
    },
  },
  methods: {
    reAnchor() {
      var scrollV,
        scrollH,
        loc = window.location;

      if ("pushState" in history) {
        history.pushState("", document.title, loc.pathname + loc.search);
      } else {
        // Prevent scrolling by storing the page's current scroll offset
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;

        loc.hash = "";

        // Restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
      }
    },
    preventDefaultBehaviors(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  },
  components: {},
};
</script>

<style lang="scss" scoped></style>
